import { mapGetters } from "vuex"

import is_page from "./IsPage"
import handles_saving from "./HandlesSaving"
import profile_utilities from "./ProfileUtilities"
import ui_utilities from "./UiUtilities"

const is_record_editor = {
    mixins: [is_page, handles_saving, profile_utilities, ui_utilities],
    mounted () {
        this.reload()
    },
    watch: {
        profile_id: "reload",
        $route: "reload"
    },
    methods: {
        grab_record_id () {
            this.record_id = parseInt(this.$route.params.id)
        },
        pre_load () {
            // local data tables stats, etc......
        },
        post_load () {
            // local data tables stats, etc......
        },
        reload (reset = false) {
            if(!this.entity) console.error(this.$root.translate("IsRecordEditor has no entity defined."))

            if(this.can_reload) {
                if(this.cleanup_before_reload) this.$store.dispatch("JANITOR", { entities: [this.entity, ...this.relation_ids] })

                this.grab_record_id()

                this.waiting = true
                this.pre_load()
                if(this.record_id) {
                    this.$store.dispatch(
                        "FETCH_RECORD",
                        {
                            entity: this.entity,
                            id: this.record_id,
                            query: this.reload_query
                        }
                    ).then(() => {
                        this.shell_record = null
                        this.post_load()
                    }).catch(error => {
                        this.$error(error.message)
                    }).then(() => {
                        this.waiting = false
                    })
                } else {
                    this.$store.dispatch(
                        "FETCH_RECORD_SHELL",
                        { entity: this.entity, reset }
                    ).then(record => {
                        this.shell_record = record
                        this.post_load()
                    }).catch(error => {
                        this.$error(error.message)
                    }).then(() => {
                        this.waiting = false
                    })
                }
            }
        },
        save (value, field) {
            if(this.edited_record) {
                if(this.edited_record[field] !== value) this.edited_record[field] = value
                if(this.edited_record.id) return this.save_field(this.edited_record[field], field)
            }
            return Promise.resolve()
        },
        confirm_record_delete () {
            this.confirm(
                {
                    type: "error",
                    title: this.$root.translate("Delete Record"),
                    message: this.$root.translate("Do you really want to delete this record? There is no undo..."),
                    cancel: this.$root.translate("Keep"),
                    ok: this.$root.translate("Delete")
                },
                "delete-record"
            )
        },
        record_delete () {
            this.deleting_record = true
            this.$store.dispatch(
                "RECORD_DELETE",
                {
                    entity: this.entity,
                    id: this.record_id
                }
            ).then(record => {
                this.record_deleted(record)
            }).catch(this.receive_error).then(() => {
                this.deleting_record = false
            })
        },
        record_deleted (record) {
            console.log("Record deleted", record)
        },
        record_restore () {
            this.restoring_record = true
            this.$store.dispatch(
                "RECORD_RESTORE",
                {
                    entity: this.entity,
                    id: this.record_id
                }
            ).then(record => {
                this.record_restored(record)
            }).catch(this.receive_error).then(() => {
                this.restoring_record = false
            })
        },
        record_restored (record) {
            console.log("Record restored", record)
        },
        confirm ({ type, title, message, ok, cancel }) {
            this.$confirm(
                title,
                message,
                ok,
                cancel,
                type
            ).then(() => {
                this.record_delete()
            }).catch(() => {
            }).then(() => {
                this.$store.dispatch("CONFIRM", { confirm: {} })
            })
        }
    },
    computed: {
        ...mapGetters(["entity_record"]),
        can_reload () {
            return this.is_public_page || this.profile_id
        },
        cleanup_before_reload () {
            return true
        },
        reload_query () {
            return { relation_ids: this.relation_ids }
        },
        edited_record () {
            if(this.shell_record) return this.shell_record
            if(!this.entity || !this.record_id) return null
            return this.entity_record(this.entity, this.record_id)
        },
        page_title () {
            const record = this.edited_record
            const entity_name = this.$root.translate(this.entityName, {}, 1)
            if(!record || !record.id) return this.$root.translate(`New ${entity_name}`)
            return record.name || record.title || record.email || entity_name
        }
    },
    data () {
        return {
            // NEEDS TO BE OVERRIDEN
            entityName: "record:::records",
            relation_ids: [],
            shell_record: null,
            deleting_record: false,
            restoring_record: false
        }
    }
}

export default is_record_editor
